import React, { useState } from "react"
import Modal from "./Modal"
import { primaryButtonStyle, secondaryButtonStyle } from "../styles/commonStyles"

const LoginSuccessModal = ({ isOpen, onClose }) => {
	const [copySuccess, setCopySuccess] = useState(false)
	const loginUrl = process.env.REACT_APP_WEB_URL + "/member/check-sso"

	const handleCopyText = async () => {
		try {
			await navigator.clipboard.writeText(loginUrl)
			setCopySuccess(true)
			setTimeout(() => setCopySuccess(false), 2000)
		} catch (err) {
			console.error("Failed to copy: ", err)
		}
	}

	const footer = (
		<>
			<button
				onClick={handleCopyText}
				style={{
					...secondaryButtonStyle,
					backgroundColor: copySuccess ? "#10B981" : "#6B7280",
					color: "white",
					minWidth: "120px",
				}}
			>
				{copySuccess ? "✓ คัดลอกแล้ว" : "คัดลอก URL"}
			</button>
			<button
				onClick={onClose}
				style={{
					...primaryButtonStyle,
				}}
			>
				ปิด
			</button>
		</>
	)

	return (
		<Modal isOpen={isOpen} onClose={onClose} title="เข้าสู่ระบบสำเร็จ" footer={footer} size="md">
			<div style={{ textAlign: "center", padding: "20px 0" }}>
				<div
					style={{
						color: "#059669",
						fontSize: "48px",
						marginBottom: "16px",
					}}
				>
					<span role="img" aria-label="success">
						✅
					</span>
				</div>
				<div
					style={{
						fontSize: "16px",
						marginBottom: "20px",
						lineHeight: 1.6,
						color: "#374151",
					}}
				>
					<strong>Login API สำเร็จ</strong>
					<br />
					กรุณาเข้าหน้าด้านล่างเพื่อสร้าง cookie ที่หน้า web ค่ะ
				</div>
				<div
					style={{
						background: "#F3F4F6",
						border: "1px solid #D1D5DB",
						borderRadius: "8px",
						padding: "12px 16px",
						fontFamily: "monospace",
						fontSize: "14px",
						color: "#1F2937",
						textAlign: "center",
						userSelect: "all",
					}}
				>
					<a href={loginUrl} target="_blank" rel="noopener noreferrer">
						{loginUrl}
					</a>
				</div>
			</div>
		</Modal>
	)
}

export default LoginSuccessModal
